
        import 'PeachyChoice.cad3389.css-module'
        export default {"PeachyChoice":"PeachyChoice_PeachyChoice_cad3389"}
    